/* Column layout inspired by Testimonials Columns, Efferd / Shaban Haider:
   https://21st.dev/@sshahaider/components/testimonials-columns-1
   Native theme adaptation: preserve authentic review blocks and all mobile content. */
if (!customElements.get('cabane-google-reviews')) {
  customElements.define('cabane-google-reviews', class extends HTMLElement {
    connectedCallback() {
      this.rail = this.querySelector('[data-review-rail]');
      this.cards = [...this.querySelectorAll('[data-review-card]')];
      if (!this.rail || !this.cards.length) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.controls = this.querySelector('[data-review-controls]');
      this.previous = this.querySelector('[data-review-previous]');
      this.next = this.querySelector('[data-review-next]');
      this.position = this.querySelector('[data-review-position]');
      this.desktop = matchMedia('(min-width: 990px)');
      this.mobile = matchMedia('(max-width: 749px)');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = false;
      this.previous.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.rail.addEventListener('scroll', () => this.update(), { ...options, passive: true });
      this.rail.addEventListener('keydown', event => {
        if (this.columnMode || event.target !== this.rail || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault(); this.move(event.key === 'ArrowRight' ? 1 : -1);
      }, options);
      // Expand the originals when using the keyboard so no focused link is clipped.
      this.rail.addEventListener('focusin', event => {
        if (this.columnMode && event.target !== this.rail) { this.paused = true; this.updatePause(); }
      }, options);
      this.rail.addEventListener('focusout', event => {
        if (!this.rail.contains(event.relatedTarget)) { this.paused = false; this.updatePause(); }
      }, options);
      this.desktop.addEventListener('change', () => this.layout(), options);
      this.reduced.addEventListener('change', () => this.layout(), options);
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this.rail);
      this.cards.forEach(card => this.observer.observe(card));
      this.visibility = new IntersectionObserver(entries => {
        this.classList.toggle('is-visible', entries[0].isIntersecting);
      });
      this.visibility.observe(this);
      this.layout();
    }
    layout() {
      this.rail.replaceChildren(...this.cards);
      this.columnMode = false;
      this.classList.toggle('has-review-columns', this.columnMode);
      this.classList.remove('reviews-static');
      this.rail.scrollLeft = 0;
      this.rail.tabIndex = 0;
      this.rail.setAttribute('aria-label', this.columnMode ? 'Avis des clients du magasin en colonnes' : 'Avis des clients du magasin');
      if (this.columnMode) {
        for (let i = 0; i < 3; i++) {
          const column = document.createElement('div'); column.className = 'cabane-google-reviews__column';
          column.style.setProperty('--review-duration', `${44 + i * 7}s`);
          const group = document.createElement('div'); group.className = 'cabane-google-reviews__group';
          this.cards.filter((_, index) => index % 3 === i).forEach(card => group.append(card));
          column.append(group); this.rail.append(column);
        }
      }
      this.controls.hidden = false;
      this.updatePause(); this.update();
    }
    updatePause() {
      this.classList.toggle('is-paused', this.paused);
    }
    measure() {
      const gap = parseFloat(getComputedStyle(this.rail).columnGap) || 0;
      const step = this.cards[0].getBoundingClientRect().width + gap;
      return { step, visible: Math.max(1, Math.round((this.rail.clientWidth + gap) / step)) };
    }
    move(direction) {
      const { step, visible } = this.measure();
      this.rail.scrollBy({ left: direction * step * visible, behavior: this.reduced.matches ? 'auto' : 'smooth' });
    }
    update() {
      if (!this.mobile.matches) this.rail.style.removeProperty('--review-mobile-height');
      if (this.columnMode) {
        if (!this.paused) {
          this.rail.querySelectorAll('.cabane-google-reviews__column').forEach(column => {
            const distance = Math.max(0, column.firstElementChild.scrollHeight - this.rail.clientHeight);
            const travel = `-${distance}px`;
            if (column.style.getPropertyValue('--review-travel') !== travel) {
              column.style.setProperty('--review-travel', travel);
            }
          });
        }
        return;
      }
      if (this.controls.hidden) return;
      const { step, visible } = this.measure(); if (!step) return;
      const first = Math.min(this.cards.length, Math.round(this.rail.scrollLeft / step) + 1);
      const last = Math.min(this.cards.length, first + visible - 1);
      if (this.mobile.matches) {
        const height = Math.ceil(this.cards[first - 1].getBoundingClientRect().height);
        if (height > 0 && this.rail.style.getPropertyValue('--review-mobile-height') !== height + 'px') {
          this.rail.style.setProperty('--review-mobile-height', height + 'px');
        }
      }
      const label = first === last ? `${first} / ${this.cards.length}` : `${first}–${last} / ${this.cards.length}`;
      if (this.position.textContent !== label) this.position.textContent = label;
      this.previous.disabled = this.rail.scrollLeft < 2;
      this.next.disabled = this.rail.scrollLeft + this.rail.clientWidth >= this.rail.scrollWidth - 2;
    }
    disconnectedCallback() {
      this.controller?.abort(); this.observer?.disconnect(); this.visibility?.disconnect();
      if (this.rail && this.cards) this.rail.replaceChildren(...this.cards);
    }
  });
}


